import {
    Avatar,
    Flex,
    Icon
} from "@chakra-ui/react";
import { MdAddAPhoto } from "react-icons/md";

const Picture = ({ nomeCompleto, foto, size = "lg" }) => {
    const getLogoUrl = (logo) => {
        if (logo?.img?.data && logo?.img?.contentType) {
            return `data:${logo.img.contentType};base64,${logo.img.data}`;
        }
        return null;
    };

    return (
        <>
            {foto ? (
                <Avatar
                    name={nomeCompleto || ""}
                    src={getLogoUrl(foto)}
                    size={size}
                    borderRadius="full"
                    objectFit="cover"
                />
            ) : (
                <Flex align="center" justify="center" h={70} w={70} bg="gray.100" borderRadius="full">
                    <Icon as={MdAddAPhoto} color="gray.400" boxSize={8} />
                </Flex>
            )}

        </>
    )
}



export default Picture;
